import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import AddButton from '../addButton';
import { SaveButton, DeleteButton } from '../modalButtons';

var DAYS = ['monday','tuesday','wednesday','thursday','friday','saturday','sunday'];
var DAY_FULL = { monday:'Monday', tuesday:'Tuesday', wednesday:'Wednesday', thursday:'Thursday', friday:'Friday', saturday:'Saturday', sunday:'Sunday' };

var TIMEZONES = [
    'America/New_York','America/Chicago','America/Denver','America/Los_Angeles',
    'America/Anchorage','Pacific/Honolulu','America/Halifax','America/Phoenix',
    'Europe/London','Europe/Amsterdam','Europe/Moscow','Africa/Cairo',
    'Asia/Dubai','Asia/Bangkok','Asia/Hong_Kong','Asia/Tokyo','Australia/Melbourne','Pacific/Fiji'
];

var SECTIONS = ['Business Hours Groups', 'Holidays'];

var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
var WEEKDAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
var NTH_LABELS = ['1st','2nd','3rd','4th','Last'];

var TIME_SUGGESTIONS = (function() {
    var opts = [];
    for (var h = 0; h < 24; h++) {
        for (var m = 0; m < 60; m += 30) {
            var hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
            var mm = m === 0 ? '00' : '30';
            var ampm = h < 12 ? 'AM' : 'PM';
            opts.push(hour12 + ':' + mm + ' ' + ampm);
        }
    }
    return opts;
})();

// Convert stored "HH:MM" 24h to "H:MM AM/PM" for display
function to12h(val) {
    if (!val) return '';
    var parts = val.match(/^(\d{1,2}):(\d{2})$/);
    if (!parts) return val; // already formatted or custom text
    var h = parseInt(parts[1], 10), mm = parts[2];
    var ampm = h < 12 ? 'AM' : 'PM';
    var hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
    return hour12 + ':' + mm + ' ' + ampm;
}

// Convert "H:MM AM/PM" back to "HH:MM" for storage
function to24h(val) {
    if (!val) return '';
    var parts = val.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if (!parts) return val;
    var h = parseInt(parts[1], 10), mm = parts[2], ampm = parts[3].toUpperCase();
    if (ampm === 'AM' && h === 12) h = 0;
    if (ampm === 'PM' && h !== 12) h += 12;
    return h.toString().padStart(2, '0') + ':' + mm;
}

function TimeInput(props) {
    return (
        <span>
            <input
                list="bhTimeSuggestions"
                value={to12h(props.value)}
                onChange={function(e) {
                    var converted = to24h(e.target.value);
                    props.onChange({ target: { value: converted || e.target.value } });
                }}
                placeholder="8:00 AM"
                style={{ padding: '5px 8px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '13px', color: '#333', width: '90px' }}
            />
        </span>
    );
}

function holidayMatchesDate(hol, dateStr) {
    var type = hol.type || 'specific';
    if (type === 'fixed') {
        var parts = dateStr.split('-');
        var year = parseInt(parts[0], 10);
        var exactMonth = parseInt(parts[1], 10), exactDay = parseInt(parts[2], 10);
        if (!hol.observed) return exactMonth === hol.month && exactDay === hol.day;
        // With observed rule: if holiday falls on Sat observe Fri, Sun observe Mon
        var holDate = new Date(year + '-' + String(hol.month).padStart(2,'0') + '-' + String(hol.day).padStart(2,'0') + 'T12:00:00');
        var dow = holDate.getDay();
        if (dow === 6) holDate.setDate(holDate.getDate() - 1); // Sat → Fri
        else if (dow === 0) holDate.setDate(holDate.getDate() + 1); // Sun → Mon
        return dateStr === holDate.toLocaleDateString('en-CA');
    }
    if (type === 'nthWeekday') {
        var d = new Date(dateStr + 'T12:00:00');
        if (d.getMonth() + 1 !== hol.month) return false;
        if (d.getDay() !== hol.weekday) return false;
        if (hol.nth === 5) {
            var next = new Date(d); next.setDate(d.getDate() + 7);
            return next.getMonth() !== d.getMonth();
        }
        return Math.ceil(d.getDate() / 7) === hol.nth;
    }
    return hol.date === dateStr;
}

function holidayDisplayText(h) {
    var type = h.type || 'specific';
    if (type === 'fixed') {
        return (MONTHS[h.month - 1] || '') + ' ' + h.day + (h.observed ? ' (observed)' : '');
    }
    if (type === 'nthWeekday') {
        var nthLabel = h.nth === 5 ? 'Last' : (NTH_LABELS[h.nth - 1] || '');
        return nthLabel + ' ' + (WEEKDAYS[h.weekday] || '') + ' of ' + (MONTHS[h.month - 1] || '');
    }
    return h.date ? new Date(h.date + 'T12:00:00').toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : '—';
}

function getGroupStatus(g, allHolidays) {
    var tz = g.timezone || 'America/New_York';
    var now = new Date();
    var dateStr = now.toLocaleDateString('en-CA', { timeZone: tz }); // YYYY-MM-DD
    var dayName = now.toLocaleDateString('en-US', { weekday: 'long', timeZone: tz }).toLowerCase();
    var timeStr = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: tz });

    // Holiday overrides take priority
    var hs = g.holidaySettings || {};
    for (var holId in hs) {
        var holData = (allHolidays || {})[holId];
        if (holData && holidayMatchesDate(holData, dateStr)) {
            var setting = hs[holId];
            if (setting.closed) return { open: false, note: holData.name };
            var inWindow = timeStr >= (setting.start || '00:00') && timeStr < (setting.end || '23:59');
            return { open: inWindow, note: holData.name };
        }
    }

    // Regular schedule
    var ds = (g.schedule || {})[dayName] || {};
    if (!ds.open) return { open: false };
    var open = timeStr >= (ds.start || '00:00') && timeStr < (ds.end || '23:59');
    return { open: open };
}

function defaultSchedule() {
    var s = {};
    DAYS.forEach(function(d) {
        s[d] = { open: (d !== 'saturday' && d !== 'sunday'), start: '08:00', end: '17:00' };
    });
    return s;
}

class BusinessHours extends Component {
    constructor(props) {
        super(props);
        this.state = {
            section: 'Business Hours Groups',
            // BH Groups
            editGroup: null,
            isNewGroup: false,
            // Holidays
            editHoliday: null,
            isNewHoliday: false,
            // Shared
            sortBy: 'name',
            sortOrder: 1,
            filterText: '',
            loading: false,
            error: ''
        };
    }

    cancel = () => {
        this.setState({ editGroup: null, isNewGroup: false, editHoliday: null, isNewHoliday: false, loading: false, error: '' });
    }

    componentWillReceiveProps() {
        if (this.state.loading) this.cancel();
    }

    switchSection = (e) => {
        this.setState({ section: e.target.value, filterText: '', sortBy: 'name', sortOrder: 1 });
    }

    // ── Business Hours Group handlers ─────────────────────────────────────────
    openGroup = (id) => () => {
        var data = (this.props.data.BusinessHours || {}).groups || {};
        var item = data[id];
        if (!item) return;
        var copy = JSON.parse(JSON.stringify(item));
        if (!copy.schedule) copy.schedule = defaultSchedule();
        this.setState({ editGroup: copy, isNewGroup: false, error: '' });
    }

    newGroup = () => {
        this.setState({ editGroup: { name: '', timezone: 'America/New_York', schedule: defaultSchedule() }, isNewGroup: true, error: '' });
    }

    setGroupField = (field) => (e) => {
        var val = e.target.value;
        this.setState(function(s) { return { editGroup: Object.assign({}, s.editGroup, { [field]: val }) }; });
    }

    toggleGroupHoliday = (holidayId) => {
        this.setState(function(s) {
            var hs = Object.assign({}, s.editGroup.holidaySettings || {});
            if (hs[holidayId]) {
                delete hs[holidayId];
            } else {
                hs[holidayId] = { enabled: true, closed: true, start: '08:00', end: '17:00' };
            }
            return { editGroup: Object.assign({}, s.editGroup, { holidaySettings: hs }) };
        });
    }

    setGroupHolidaySetting = (holidayId, field, value) => {
        this.setState(function(s) {
            var hs = Object.assign({}, s.editGroup.holidaySettings || {});
            hs[holidayId] = Object.assign({}, hs[holidayId], { [field]: value });
            return { editGroup: Object.assign({}, s.editGroup, { holidaySettings: hs }) };
        });
    }

    setSchedule = (day, field, value) => {
        this.setState(function(s) {
            var sched = Object.assign({}, s.editGroup.schedule);
            sched[day] = Object.assign({}, sched[day], { [field]: value });
            return { editGroup: Object.assign({}, s.editGroup, { schedule: sched }) };
        });
    }

    saveGroup = () => {
        var item = this.state.editGroup;
        if (!item.name || !item.name.trim()) { this.setState({ error: 'Name is required.' }); return; }
        this.props.ws.send(JSON.stringify({ route: 'saveBusinessHoursGroup', item: item }));
        this.setState({ loading: true, error: '' });
    }

    doDeleteGroup = () => {
        this.props.ws.send(JSON.stringify({ route: 'deleteBusinessHoursGroup', id: this.state.editGroup.id }));
        this.setState({ loading: true });
    }

    // ── Holiday handlers ──────────────────────────────────────────────────────
    openHoliday = (id) => () => {
        var data = (this.props.data.BusinessHours || {}).holidays || {};
        var item = data[id];
        if (!item) return;
        this.setState({ editHoliday: Object.assign({}, item), isNewHoliday: false, error: '' });
    }

    newHoliday = () => {
        this.setState({ editHoliday: { name: '', type: 'fixed', month: 12, day: 25 }, isNewHoliday: true, error: '' });
    }

    setHolidayField = (field) => (e) => {
        var val = e.target.value;
        this.setState(function(s) { return { editHoliday: Object.assign({}, s.editHoliday, { [field]: val }) }; });
    }

    saveHoliday = () => {
        var item = this.state.editHoliday;
        var type = item.type || 'specific';
        if (!item.name || !item.name.trim()) { this.setState({ error: 'Name is required.' }); return; }
        if (type === 'fixed' && (!item.month || !item.day)) { this.setState({ error: 'Month and day are required.' }); return; }
        if (type === 'nthWeekday' && (!item.month || item.nth == null || item.weekday == null)) { this.setState({ error: 'Month, occurrence, and weekday are required.' }); return; }
        if (type === 'specific' && !item.date) { this.setState({ error: 'Date is required.' }); return; }
        this.props.ws.send(JSON.stringify({ route: 'saveBusinessHoursHoliday', item: item }));
        this.setState({ loading: true, error: '' });
    }

    doDeleteHoliday = () => {
        this.props.ws.send(JSON.stringify({ route: 'deleteBusinessHoursHoliday', id: this.state.editHoliday.id }));
        this.setState({ loading: true });
    }

    // ── Sort helpers ──────────────────────────────────────────────────────────
    toggleSort = (col) => () => {
        this.setState(function(s) { return { sortBy: col, sortOrder: s.sortBy === col ? -s.sortOrder : 1 }; });
    }

    sortIcon = (col) => {
        return this.state.sortBy === col ? (this.state.sortOrder === 1 ? ' ▲' : ' ▼') : '';
    }

    render() {
        if (!this.props.active) return <div></div>;

        var section = this.state.section;
        var filter = this.state.filterText.toLowerCase();
        var sb = this.state.sortBy, so = this.state.sortOrder;

        // ── Section dropdown ─────────────────────────────────────────────────
        var sectionDropdown = (
            <select
                value={section}
                onChange={this.switchSection}
                style={{ height: '38px', padding: '0 10px', border: '1px solid #ddd', borderRadius: '4px', fontWeight: 'bold', fontSize: '18px', color: '#137', marginBottom: '15px', marginTop: '10px' }}
            >
                {SECTIONS.map(function(s) { return <option key={s} value={s}>{s}</option>; })}
            </select>
        );

        // ══════════════════════════════════════════════════════════════════════
        // HOLIDAYS SECTION
        // ══════════════════════════════════════════════════════════════════════
        if (section === 'Holidays') {
            var hRaw = (this.props.data.BusinessHours || {}).holidays || {};
            var hArray = Object.keys(hRaw).map(function(id) { return hRaw[id]; });

            hArray.sort(function(a, b) {
                var av = (a[sb] || '').toLowerCase(), bv = (b[sb] || '').toLowerCase();
                return av > bv ? so : av < bv ? -so : 0;
            });

            var holidayRows = hArray.map(function(h) {
                var display = holidayDisplayText(h);
                return (
                    <tr className="dataRow" key={h.id} onClick={this.openHoliday(h.id)} style={{ cursor: 'pointer', alignItems: 'center' }}>
                        <td style={{ minWidth: '200px', textAlign: 'left' }}>{h.name}</td>
                        <td style={{ minWidth: '200px', textAlign: 'left' }}>{display}</td>
                    </tr>
                );
            }.bind(this));

            // Holiday modal
            var holidayModal = null;
            if (this.state.editHoliday) {
                var hd = this.state.editHoliday;
                holidayModal = (
                    <div className="blackout" tabIndex="1" autoFocus>
                        <div className="pop" style={{ display: 'flex', flexDirection: 'column', width: '420px', maxWidth: '94vw', padding: 0, position: 'relative', overflow: 'hidden' }}>
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <div style={{ background: '#002f5f', padding: '20px 28px 14px', color: '#fff' }}>
                                <div style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.55)', marginBottom: '4px' }}>
                                    {this.state.isNewHoliday ? 'New Holiday' : 'Edit Holiday'}
                                </div>
                                <div style={{ fontSize: '20px', fontWeight: '700' }}>{hd.name || 'Holiday'}</div>
                            </div>
                            <div style={{ padding: '22px 28px 26px' }}>
                                <label style={labelStyle}>Holiday Name</label>
                                <input type="text" value={hd.name || ''} onChange={this.setHolidayField('name')} placeholder="e.g. Thanksgiving Day" style={inputStyle} />

                                <label style={Object.assign({}, labelStyle, { marginTop: '16px' })}>Recurrence</label>
                                <select value={hd.type || 'specific'} onChange={this.setHolidayField('type')} style={inputStyle}>
                                    <option value="fixed">Same day every year (e.g. Dec 25)</option>
                                    <option value="nthWeekday">Nth weekday of month (e.g. 4th Thursday)</option>
                                    <option value="specific">Specific date (one-time)</option>
                                </select>

                                {(hd.type === 'fixed' || !hd.type && hd.month) && (
                                    <div style={{ marginTop: '16px' }}>
                                        <div style={{ display: 'flex', gap: '12px' }}>
                                            <div style={{ flex: 1 }}>
                                                <label style={labelStyle}>Month</label>
                                                <select value={hd.month || 1} onChange={function(e) { this.setState(function(s) { return { editHoliday: Object.assign({}, s.editHoliday, { month: parseInt(e.target.value, 10) }) }; }); }.bind(this)} style={inputStyle}>
                                                    {MONTHS.map(function(m, i) { return <option key={i} value={i + 1}>{m}</option>; })}
                                                </select>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <label style={labelStyle}>Day</label>
                                                <select value={hd.day || 1} onChange={function(e) { this.setState(function(s) { return { editHoliday: Object.assign({}, s.editHoliday, { day: parseInt(e.target.value, 10) }) }; }); }.bind(this)} style={inputStyle}>
                                                    {Array.from({ length: 31 }, function(_, i) { return <option key={i + 1} value={i + 1}>{i + 1}</option>; })}
                                                </select>
                                            </div>
                                        </div>
                                        <div onClick={function() { this.setState(function(s) { return { editHoliday: Object.assign({}, s.editHoliday, { observed: !s.editHoliday.observed }) }; }); }.bind(this)}
                                            style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px', cursor: 'pointer', userSelect: 'none' }}>
                                            <div style={{ width: '16px', height: '16px', borderRadius: '3px', border: '2px solid #002f5f', background: hd.observed ? '#002f5f' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                {hd.observed && <svg width="9" height="7" viewBox="0 0 10 8"><path fill="#fff" d="M10 1.5L3.5 8L0 4.5L1.5 3L3.5 5L8.5 0L10 1.5Z"></path></svg>}
                                            </div>
                                            <span style={{ fontSize: '13px', color: '#444' }}>Apply observed day rule <span style={{ color: '#888' }}>(Sat → Fri, Sun → Mon)</span></span>
                                        </div>
                                    </div>
                                )}

                                {hd.type === 'nthWeekday' && (
                                    <div style={{ marginTop: '16px' }}>
                                        <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
                                            <div style={{ flex: 1 }}>
                                                <label style={labelStyle}>Occurrence</label>
                                                <select value={hd.nth != null ? hd.nth : 1} onChange={function(e) { this.setState(function(s) { return { editHoliday: Object.assign({}, s.editHoliday, { nth: parseInt(e.target.value, 10) }) }; }); }.bind(this)} style={inputStyle}>
                                                    {NTH_LABELS.map(function(l, i) { return <option key={i} value={i + 1}>{l}</option>; })}
                                                </select>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <label style={labelStyle}>Weekday</label>
                                                <select value={hd.weekday != null ? hd.weekday : 4} onChange={function(e) { this.setState(function(s) { return { editHoliday: Object.assign({}, s.editHoliday, { weekday: parseInt(e.target.value, 10) }) }; }); }.bind(this)} style={inputStyle}>
                                                    {WEEKDAYS.map(function(w, i) { return <option key={i} value={i}>{w}</option>; })}
                                                </select>
                                            </div>
                                        </div>
                                        <div>
                                            <label style={labelStyle}>Month</label>
                                            <select value={hd.month || 11} onChange={function(e) { this.setState(function(s) { return { editHoliday: Object.assign({}, s.editHoliday, { month: parseInt(e.target.value, 10) }) }; }); }.bind(this)} style={inputStyle}>
                                                {MONTHS.map(function(m, i) { return <option key={i} value={i + 1}>{m}</option>; })}
                                            </select>
                                        </div>
                                    </div>
                                )}

                                {(hd.type === 'specific' || (!hd.type && !hd.month)) && (
                                    <div style={{ marginTop: '16px' }}>
                                        <label style={labelStyle}>Date</label>
                                        <DatePicker
                                            selected={hd.date ? (function() { var p = hd.date.match(/^(\d{4})-(\d{2})-(\d{2})/); return p ? new Date(+p[1], +p[2]-1, +p[3]) : null; })() : null}
                                            onChange={function(date) {
                                                if (!date) { this.setState(function(s) { return { editHoliday: Object.assign({}, s.editHoliday, { date: '' }) }; }); return; }
                                                var iso = date.getFullYear() + '-' + String(date.getMonth()+1).padStart(2,'0') + '-' + String(date.getDate()).padStart(2,'0');
                                                this.setState(function(s) { return { editHoliday: Object.assign({}, s.editHoliday, { date: iso }) }; });
                                            }.bind(this)}
                                            placeholderText="Select date"
                                            dateFormat="yyyy-MM-dd"
                                            customInput={<input style={{ width: '100%', padding: '9px 12px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '14px', color: '#222', background: '#fff', boxSizing: 'border-box' }} />}
                                        />
                                    </div>
                                )}

                                {this.state.error && <div className="error" style={{ margin: '12px 0' }}>{this.state.error}</div>}

                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
                                    {!this.state.isNewHoliday && <DeleteButton onClick={this.doDeleteHoliday} />}
                                    {this.state.loading ? <div className="loader"></div> : <SaveButton onClick={this.saveHoliday} />}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }

            return (
                <div style={{ width: '100%' }}>
                    {holidayModal}
                    <AddButton onClick={this.newHoliday} />
                    {sectionDropdown}
                    <table style={{ float: 'left', width: '100%' }}>
                        <thead>
                            <tr className="dataRow">
                                <th style={{ minWidth: '200px', cursor: 'pointer', textAlign: 'left' }} onClick={this.toggleSort('name')}>Name{this.sortIcon('name')}</th>
                                <th style={{ minWidth: '200px', textAlign: 'left' }}>When</th>
                            </tr>
                        </thead>
                        <tbody>
                            {holidayRows.length > 0 ? holidayRows : (
                                <tr><td colSpan="2" style={{ padding: '32px', textAlign: 'center', color: '#bbb', fontSize: '14px', fontStyle: 'italic' }}>No holidays yet — click the + button to add one.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            );
        }

        // ══════════════════════════════════════════════════════════════════════
        // BUSINESS HOURS GROUPS SECTION
        // ══════════════════════════════════════════════════════════════════════
        var rawData = (this.props.data.BusinessHours || {}).groups || {};
        var dataArray = Object.keys(rawData).map(function(id) { return rawData[id]; });

        if (filter) {
            dataArray = dataArray.filter(function(g) {
                return (g.name || '').toLowerCase().indexOf(filter) >= 0 ||
                       (g.timezone || '').toLowerCase().indexOf(filter) >= 0;
            });
        }
        dataArray.sort(function(a, b) {
            var av = (a[sb] || '').toLowerCase(), bv = (b[sb] || '').toLowerCase();
            return av > bv ? so : av < bv ? -so : 0;
        });

        var allHolidays = (this.props.data.BusinessHours || {}).holidays || {};
        var groupRows = dataArray.map(function(g) {
            var sched = g.schedule || {};
            var status = getGroupStatus(g, allHolidays);
            return (
                <tr className="dataRow" key={g.id} onClick={this.openGroup(g.id)} style={{ cursor: 'pointer', alignItems: 'center' }}>
                    <td style={{ minWidth: '220px', textAlign: 'left' }}>{g.name}</td>
                    <td style={{ minWidth: '150px', textAlign: 'left' }}>{g.timezone || '—'}</td>
                    <td style={{ minWidth: '175px', textAlign: 'left', verticalAlign: 'middle' }}>
                        <div style={{ display: 'flex', gap: '3px', alignItems: 'center' }}>
                            {DAYS.map(function(d) {
                                var ds = sched[d] || {};
                                var isOpen = ds.open;
                                var label = d.charAt(0).toUpperCase();
                                return (
                                    <div key={d} title={DAY_FULL[d] + ': ' + (isOpen ? ds.start + '–' + ds.end : 'Closed')}
                                        style={{ width: '22px', height: '22px', borderRadius: '50%', background: isOpen ? '#002f5f' : '#dde2ea', color: isOpen ? '#fff' : '#dde2ea', fontSize: '9px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {label}
                                    </div>
                                );
                            })}
                        </div>
                    </td>
                    <td style={{ minWidth: '100px', textAlign: 'left', verticalAlign: 'middle' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            {status.open ? (
                                <div style={{ backgroundColor: '#002f5f', color: 'white', borderRadius: '50%', height: '20px', width: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
                                    <svg width="10" height="8" viewBox="0 0 10 8"><path fill="currentColor" d="M10 1.5L3.5 8L0 4.5L1.5 3L3.5 5L8.5 0L10 1.5Z"></path></svg>
                                </div>
                            ) : (
                                <div style={{ backgroundColor: '#e74c3c', color: 'white', borderRadius: '50%', height: '20px', width: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
                                    <svg width="8" height="8" viewBox="0 0 8 8"><path fill="currentColor" d="M7 1L4 4L7 7L6 8L3 5L0 8L-1 7L2 4L-1 1L0 0L3 3L6 0Z" transform="translate(1,0)"></path></svg>
                                </div>
                            )}
                            <span>{status.open ? 'Open' : 'Closed'}</span>
                        </div>
                    </td>
                </tr>
            );
        }.bind(this));

        // Group modal
        var groupModal = null;
        if (this.state.editGroup) {
            var g = this.state.editGroup;
            var sched = g.schedule || {};
            groupModal = (
                <div className="blackout" tabIndex="1" autoFocus>
                    <div className="pop" style={{ display: 'flex', flexDirection: 'column', width: '560px', maxWidth: '96vw', padding: 0, position: 'relative', overflow: 'hidden' }}>
                        <div className="viewCloser" onClick={this.cancel}></div>
                        <div style={{ background: '#002f5f', padding: '20px 28px 14px', color: '#fff', flexShrink: 0 }}>
                            <div style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.55)', marginBottom: '4px' }}>
                                {this.state.isNewGroup ? 'New Group' : 'Edit Group'}
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: '700' }}>{g.name || 'Business Hours Group'}</div>
                        </div>

                        <div style={{ padding: '20px 28px 26px', overflowY: 'auto', maxHeight: 'calc(85vh - 90px)' }}>
                            <datalist id="bhTimeSuggestions">
                                {TIME_SUGGESTIONS.map(function(t) { return <option key={t} value={t} />; })}
                            </datalist>
                            <div style={{ display: 'flex', gap: '14px', marginBottom: '20px' }}>
                                <div style={{ flex: 2 }}>
                                    <label style={labelStyle}>Group Name</label>
                                    <input type="text" value={g.name || ''} onChange={this.setGroupField('name')} placeholder="e.g. Main Office Hours" style={inputStyle} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={labelStyle}>Time Zone</label>
                                    <select value={g.timezone || 'America/New_York'} onChange={this.setGroupField('timezone')} style={inputStyle}>
                                        {TIMEZONES.map(function(tz) { return <option key={tz} value={tz}>{tz}</option>; })}
                                    </select>
                                </div>
                            </div>

                            <label style={labelStyle}>Weekly Schedule</label>
                            <div style={{ border: '1px solid #e8ecf2', borderRadius: '8px', overflow: 'hidden', marginBottom: '20px' }}>
                                {DAYS.map(function(day, idx) {
                                    var ds = sched[day] || { open: false, start: '08:00', end: '17:00' };
                                    return (
                                        <div key={day} style={{ display: 'flex', alignItems: 'center', padding: '8px 14px', background: idx % 2 === 0 ? '#f8fafc' : '#fff', borderBottom: idx < 6 ? '1px solid #eef1f5' : 'none', gap: '12px' }}>
                                            <div style={{ width: '90px', fontWeight: '600', fontSize: '13px', color: '#333' }}>{DAY_FULL[day]}</div>
                                            <div onClick={function(d, cur) { this.setSchedule(d, 'open', !cur); }.bind(this, day, ds.open)}
                                                style={{ display: 'flex', alignItems: 'center', gap: '7px', cursor: 'pointer', width: '82px', userSelect: 'none' }}>
                                                <div style={{ width: '32px', height: '18px', borderRadius: '9px', background: ds.open ? '#002f5f' : '#ccc', position: 'relative', flexShrink: 0, transition: 'background 0.15s' }}>
                                                    <div style={{ position: 'absolute', top: '2px', left: ds.open ? '16px' : '2px', width: '14px', height: '14px', borderRadius: '50%', background: '#fff', transition: 'left 0.15s' }}></div>
                                                </div>
                                                <span style={{ fontSize: '12px', color: ds.open ? '#002f5f' : '#999', fontWeight: '600' }}>{ds.open ? 'Open' : 'Closed'}</span>
                                            </div>
                                            {ds.open ? (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '7px', flex: 1 }}>
                                                    <TimeInput value={ds.start || '08:00'} onChange={function(d, e) { this.setSchedule(d, 'start', e.target.value); }.bind(this, day)} />
                                                    <span style={{ color: '#aaa', fontSize: '12px' }}>to</span>
                                                    <TimeInput value={ds.end || '17:00'} onChange={function(d, e) { this.setSchedule(d, 'end', e.target.value); }.bind(this, day)} />
                                                </div>
                                            ) : (
                                                <span style={{ fontSize: '12px', color: '#bbb', fontStyle: 'italic' }}>Closed all day</span>
                                            )}
                                        </div>
                                    );
                                }.bind(this))}
                            </div>

                            {(function() {
                                var allHolidays = (this.props.data.BusinessHours || {}).holidays || {};
                                var holidayList = Object.keys(allHolidays).map(function(id) { return allHolidays[id]; });
                                holidayList.sort(function(a, b) { return (a.date || '') > (b.date || '') ? 1 : -1; });
                                if (holidayList.length === 0) return null;
                                var hs = g.holidaySettings || {};
                                var selectedList = holidayList.filter(function(h) { return !!hs[h.id]; });
                                return (
                                    <div style={{ marginBottom: '20px' }}>
                                        {/* Settings for selected holidays */}
                                        {selectedList.length > 0 && (
                                            <div style={{ marginBottom: '14px' }}>
                                                <label style={labelStyle}>Observed Holidays</label>
                                                <div style={{ border: '1px solid #dde1e8', borderRadius: '8px', overflow: 'hidden' }}>
                                                {selectedList.map(function(hol, idx) {
                                                    var setting = hs[hol.id];
                                                    var display = hol.date ? new Date(hol.date + 'T12:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '';
                                                    return (
                                                        <div key={hol.id} style={{ padding: '9px 14px', background: idx % 2 === 0 ? '#f8fafc' : '#fff', borderBottom: idx < selectedList.length - 1 ? '1px solid #eef1f5' : 'none' }}>
                                                            {/* Row 1: name + date */}
                                                            <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: '6px' }}>
                                                                <span style={{ fontWeight: '600', fontSize: '13px', color: '#222' }}>{hol.name}</span>
                                                                <span style={{ fontSize: '11px', color: '#999' }}>{display}</span>
                                                            </div>
                                                            {/* Row 2: controls */}
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                <div onClick={this.setGroupHolidaySetting.bind(this, hol.id, 'closed', !setting.closed)}
                                                                    style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', userSelect: 'none', flexShrink: 0 }}>
                                                                    <div style={{ width: '28px', height: '16px', borderRadius: '8px', background: setting.closed ? '#e74c3c' : '#27ae60', position: 'relative', transition: 'background 0.15s' }}>
                                                                        <div style={{ position: 'absolute', top: '2px', left: setting.closed ? '14px' : '2px', width: '12px', height: '12px', borderRadius: '50%', background: '#fff', transition: 'left 0.15s' }}></div>
                                                                    </div>
                                                                    <span style={{ fontSize: '12px', fontWeight: '600', color: setting.closed ? '#e74c3c' : '#27ae60', width: '56px' }}>{setting.closed ? 'Closed' : 'Modified'}</span>
                                                                </div>
                                                                {!setting.closed && (
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        <TimeInput value={setting.start || '08:00'} onChange={function(id, e) { this.setGroupHolidaySetting(id, 'start', e.target.value); }.bind(this, hol.id)} />
                                                                        <span style={{ color: '#bbb', fontSize: '11px' }}>–</span>
                                                                        <TimeInput value={setting.end || '17:00'} onChange={function(id, e) { this.setGroupHolidaySetting(id, 'end', e.target.value); }.bind(this, hol.id)} />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                }.bind(this))}
                                                </div>
                                            </div>
                                        )}
                                        {/* Chip picker */}
                                        <label style={labelStyle}>Available Holidays</label>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                            {holidayList.map(function(hol) {
                                                var enabled = !!hs[hol.id];
                                                var display = hol.date ? new Date(hol.date + 'T12:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '';
                                                return (
                                                    <div key={hol.id} onClick={this.toggleGroupHoliday.bind(this, hol.id)}
                                                        style={{ cursor: 'pointer', userSelect: 'none', padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '600', transition: 'all 0.15s',
                                                            background: enabled ? '#002f5f' : '#f0f2f5',
                                                            color: enabled ? '#fff' : '#888',
                                                            border: enabled ? '1.5px solid #002f5f' : '1.5px solid #dde1e8'
                                                        }}>
                                                        {hol.name}
                                                        {display && <span style={{ fontWeight: '400', opacity: 0.7, marginLeft: '5px' }}>{display}</span>}
                                                    </div>
                                                );
                                            }.bind(this))}
                                        </div>
                                    </div>
                                );
                            }.bind(this))()}

                            {this.state.error && <div className="error" style={{ marginBottom: '12px' }}>{this.state.error}</div>}

                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                                {!this.state.isNewGroup && <DeleteButton onClick={this.doDeleteGroup} />}
                                {this.state.loading ? <div className="loader"></div> : <SaveButton onClick={this.saveGroup} />}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div style={{ width: '100%' }}>
                {groupModal}
                <AddButton onClick={this.newGroup} />
                {sectionDropdown}
                <table style={{ float: 'left', width: '100%' }}>
                    <thead>
                        <tr className="dataRow">
                            <th style={{ minWidth: '220px', cursor: 'pointer', textAlign: 'left' }} onClick={this.toggleSort('name')}>Name{this.sortIcon('name')}</th>
                            <th style={{ minWidth: '150px', cursor: 'pointer', textAlign: 'left' }} onClick={this.toggleSort('timezone')}>Time Zone{this.sortIcon('timezone')}</th>
                            <th style={{ minWidth: '175px', textAlign: 'left' }}>Schedule</th>
                            <th style={{ minWidth: '80px', textAlign: 'left' }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {groupRows.length > 0 ? groupRows : (
                            <tr><td colSpan="4" style={{ padding: '32px', textAlign: 'center', color: '#bbb', fontSize: '14px', fontStyle: 'italic' }}>No groups yet — click the + button to add one.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    }
}

const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: '700', letterSpacing: '1px',
    textTransform: 'uppercase', color: '#888', marginBottom: '8px'
};
const inputStyle = {
    width: '100%', padding: '9px 12px', border: '1px solid #ccc', borderRadius: '6px',
    fontSize: '14px', color: '#222', background: '#fff', boxSizing: 'border-box', marginBottom: '4px'
};
const deleteBtnStyle = {
    padding: '9px 18px', border: '1px solid #e74c3c', borderRadius: '6px',
    background: 'none', color: '#e74c3c', fontSize: '13px', cursor: 'pointer', fontWeight: '600'
};
const footerDeleteBtnStyle = {
    padding: '12px 28px', border: '1px solid #e74c3c', borderRadius: '6px',
    background: 'none', color: '#e74c3c', fontSize: '15px', cursor: 'pointer', fontWeight: '600',
    appearance: 'none', WebkitAppearance: 'none'
};
const footerSaveBtnStyle = {
    padding: '12px 28px', border: '1px solid #002f5f', borderRadius: '6px',
    background: 'none', color: '#002f5f', fontSize: '15px', cursor: 'pointer', fontWeight: '600',
    appearance: 'none', WebkitAppearance: 'none'
};

const icon = 'menuClock';
const roles = ['View', 'Add', 'Edit', 'Delete'];
export { BusinessHours, icon, roles };
